export default function ({
    multibleFilesLabel = ':anz files selected',
    fileInputSelector = '.input--file [type="file"]'
} = {}) {
    // custom input styling
    $(fileInputSelector).on('change', event => {
        let input = event.currentTarget,
            files = input.files,
            numFiles = files ? files.length : 1,
            labelText = input.value.replace(/\\/g, '/').replace(/.*\//, ''),
            label = document.querySelector(`[for="${input.name}"]`),
            log = numFiles > 1
                ? multibleFilesLabel.replace(':anz', numFiles)
                : labelText;

        if (label) {
            label.innerText = log || label.getAttribute('data-placeholder');
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/@spinnwerk/form-helper/file-input.js